import React from 'react'
import classNames from 'classnames'

import Currency from 'components/Currency'
import T from 'components/FormattedMessage'
import LabeledValue from 'components/LabeledValue'

import { withStyles, createStyles, WithStyles, Typography, Grid, Theme } from '@material-ui/core'

import { GamePrizeInfoResponse } from 'protos'

import coinsIconUrl from 'assets/images/coins_icon.svg'
import usersIconUrl from 'assets/images/users_icon.svg'

import flameIconUrl from './assets/flame_icon.svg'

interface Props {
  feeOption: GamePrizeInfoResponse.IFeeOption
  className?: string
}

const styles = (theme: Theme) => createStyles({
  root: {
    marginTop: theme.spacing() * 4,
    marginBottom: theme.spacing() * 4,
  },
  topChoiceContainer: {
    backgroundColor: theme.palette.grey['200'],
  },
  container: {
    padding: theme.spacing() * 2,
    marginBottom: 1,
  },
  topChoiceText: {
    paddingLeft: theme.spacing() * 2,
    paddingRight: theme.spacing(),
  },
  value: {
    marginLeft: theme.spacing() * 2,
    marginRight: theme.spacing() * 2,
  },
  icons: {
    display: 'block',
    margin: `0 auto ${theme.spacing()}px`,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const TopChoice: React.SFC<InjectedProps> = ({ feeOption, classes, className }) => {
  const isHighlighted = feeOption.highlight === GamePrizeInfoResponse.Highlight.FOH_TOP
  const selectedEntryFee = Number(feeOption.entryFee!.value)

  return (
    <Grid container className={classNames(classes.root, className)} justify="center">
      {isHighlighted && (
        <Grid container item alignItems="center" className={classNames(classes.topChoiceContainer, classes.container)}>
          <Grid item>
            <img alt="" src={flameIconUrl} />
          </Grid>
          <Grid item>
            <Typography variant="body1" className={classes.topChoiceText}>
              <T id="gameconfirmation_top_title" />
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography variant="h3">
              <T id="gameconfirmation_top_subtitle" />
            </Typography>
          </Grid>
        </Grid>
      )}
      <Grid container item justify="center" className={classes.container}>
        <Grid item className={classes.value}>
          {!isHighlighted && <img alt="" className={classes.icons} src={coinsIconUrl} />}
          <LabeledValue
            label={<T id="game_totalpot" />}
            value={<Currency value={selectedEntryFee} />}
          />
        </Grid>
        <Grid item className={classes.value}>
          {!isHighlighted && <img alt="" className={classes.icons} src={usersIconUrl} />}
          <LabeledValue
            label={<T id="gameconfirmation_maxplayers" />}
            value="10"
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(TopChoice)
